import React, { useState } from 'react';
import { useLocation, useNavigate } from '../nav';
import { CustomIcon } from '../components/CustomIcons';
import { billQuery, paymentQuery, readPayment } from '../lib/transfer';
export function Review() {
  const navigate = useNavigate();
  const {
    pathname,
    search
  } = useLocation();
  const payment = readPayment(pathname + search);
  const [pressed, setPressed] = useState(false);
  const query = payment.isBill ? billQuery(payment) : paymentQuery(payment);
  const confirm = () => {
    setPressed(true);
    window.setTimeout(() => navigate(`/success?${query}`), 520);
  };
  return <main className="flex h-full w-full flex-col bg-[#061827] text-white" data-id="element-718" data-mp="2jergoogs7h1e">
      <header className="flex items-center gap-3 border-b border-white/10 px-5 pb-4 pt-14" data-id="element-719" data-mp="2ef532dx1jys2">
        <button onClick={() => navigate(-1)} className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/10" aria-label="Back" data-id="element-720" data-mp="2ehhq35hnozbz">←</button>
        <div data-id="element-721" data-mp="3ptilh390zm0p">
          <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-brand-electric" data-id="element-722" data-mp="3ptsaoom8xp5c">Final check</p>
          <h1 className="mt-1 text-lg font-extrabold" data-id="element-723" data-mp="2wtxw5jn5anxb">Review and confirm</h1>
        </div>
      </header>

      <section className="phone-scroll flex-1 overflow-y-auto px-5 py-5" data-id="element-724" data-mp="31t117434ku5a">
        <div className="rounded-[30px] bg-[linear-gradient(145deg,#132e52,#246BFE_70%,#6747E8)] p-5 shadow-glow" data-id="element-725" data-mp="36qj2q9etc739">
          <p className="text-xs font-bold uppercase tracking-[.14em] text-blue-100" data-id="element-726" data-mp="3aqtg474xpzs5">Total debit</p>
          <p className="mt-2 text-[43px] font-extrabold tracking-[-.06em] tabular-nums" data-id="element-727" data-mp="2e36n6j72kzjg">₦{payment.amount}</p>
          <p className="mt-2 text-xs leading-relaxed text-blue-100" data-id="element-728" data-mp="2iyc75cgww44w">This amount will leave your VE Bank Account only after you confirm with biometrics.</p>
        </div>

        <article className="mt-5 rounded-[27px] bg-white p-5 text-brand-navy shadow-float" data-id="element-729" data-mp="2rtjvimnvig9b">
          <div className="flex items-center justify-between border-b border-slate-100 pb-4" data-id="element-730" data-mp="1va2sqvm12ins">
            <div className="min-w-0" data-id="element-731" data-mp="1zbedontyifpn">
              <p className="text-[10px] font-extrabold uppercase tracking-[.15em] text-brand-slate" data-id="element-732" data-mp="1zad1uh549p6v">Recipient or service</p>
              <h2 className="mt-1 truncate text-lg font-extrabold" data-id="element-733" data-mp="2xojv3nfkelek">{payment.party}</h2>
            </div>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-cloud text-brand-cobalt" data-id="element-734" data-mp="3ccwrummh88a4"><CustomIcon name={payment.icon} size={19} data-id="element-735" data-mp="37dtnl4ebm637" /></span>
          </div>
          <dl className="mt-4 space-y-3.5" data-id="element-736" data-mp="2jo94mli638tx">
            <Row label="Source account" value="VE Bank Account · 0803 123 4567" data-id="element-737" data-mp="2jpah8ueu03dr" />
            <Row label={payment.isBill ? 'Biller' : 'Recipient'} value={payment.isBill ? payment.party : `${payment.party} · ${payment.account}`} data-id="element-738" data-mp="2eqfzlvslokv8" />
            <Row label={payment.isBill ? 'Reference' : 'Bank'} value={payment.isBill ? payment.account : payment.bank} data-id="element-739" data-mp="2sn2za6bxtp4u" />
            <Row label="Amount" value={`₦${payment.amount}`} data-id="element-740" data-mp="7yomnop17315" />
            <Row label="Fee" value="₦0.00" data-id="element-741" data-mp="7x5760b78w0f" />
            <Row label="Narration" value={payment.narration} data-id="element-742" data-mp="3xwcmt8c4u3t" />
            <Row label="Total debit" value={`₦${payment.amount}`} strong data-id="element-743" data-mp="3zfs4hm6314j" />
            <Row label="After confirmation" value="Your balance updates immediately." data-id="element-744" data-mp="bfazx4tu2un7" />
          </dl>
        </article>

        <p className="mt-5 px-2 text-center text-[11px] leading-relaxed text-slate-400" data-id="element-745" data-mp="gdw054935ebn">Vee prepared this information. Vee cannot approve, confirm, or complete this payment.</p>
      </section>

      <footer className="border-t border-white/10 bg-[#071f37] p-5" data-id="element-746" data-mp="6i1d7wxtwx32">
        <button onClick={confirm} disabled={pressed} className={`flex min-h-[56px] w-full items-center justify-center gap-3 rounded-2xl text-sm font-extrabold transition ${pressed ? 'bg-brand-electric text-brand-navy' : 'bg-white text-brand-navy'}`} data-id="element-747" data-mp="u8exh1a69rn3">
          <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-brand-cobalt text-white" aria-hidden="true" data-id="element-748" data-mp="pgnfvg8zuw93">◉</span>
          {pressed ? 'Authenticating…' : 'Confirm with biometrics'}
        </button>
      </footer>
    </main>;
}
function Row({
  label,
  value,
  strong = false
}: {
  label: string;
  value: string;
  strong?: boolean;
}) {
  return <div className="flex items-start justify-between gap-4" data-id="element-749" data-mp="3qflqk70a49ql">
      <dt className="max-w-[105px] text-[11px] font-bold text-brand-slate" data-id="element-750" data-mp="3leegg1anyygr">{label}</dt>
      <dd className={`max-w-[190px] text-right text-xs ${strong ? 'font-extrabold text-brand-cobalt' : 'font-bold text-brand-navy'}`} data-id="element-751" data-mp="3gfl266njz3fj">{value}</dd>
    </div>;
}